import OrderPageStoreContext from './OrderPageStoreContext';
import OrderPageStore from './orderPageStore';

const orderPageStore = new OrderPageStore();

const OrderPageStoreProvider = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element => (
  <OrderPageStoreContext.Provider value={orderPageStore}>
    {children}
  </OrderPageStoreContext.Provider>
);

export default OrderPageStoreProvider;
